import React, { useEffect, useState } from "react";
import "./VideoYoutubeList.css";

function VideoYoutubeList() {
  const [videos, setVideos] = useState([]);
  const [types, setTypes] = useState([]);
  const [newLinks, setNewLinks] = useState("");
  const [selectedType, setSelectedType] = useState("");

  // Load all categories
  const loadTypes = async () => {
    try {
      const response = await fetch("https://api.backofficemain.com/get_type_video.php");
      const data = await response.json();
      setTypes(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error("Error loading video types:", error);
    }
  };

  // Load all videos
  const loadVideos = async () => {
    try {
      const response = await fetch("https://api.backofficemain.com/get_list_video.php");
      const data = await response.json();
      setVideos(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error("Error loading videos:", error);
    }
  };

  useEffect(() => {
    loadTypes();
    loadVideos();
  }, []);

  // Add new videos
  const handleAddVideos = async () => {
    if (!newLinks.trim() || !selectedType) {
      alert("Please enter at least one link and select a category!");
      return;
    }

    const links = newLinks
      .split("\n")
      .map((link) => link.trim())
      .filter((link) => link);

    try {
      const formData = new FormData();
      formData.append("type_id", selectedType);
      formData.append("links", JSON.stringify(links));

      const response = await fetch("https://api.backofficemain.com/add_list_video.php", {
        method: "POST",
        body: formData,
      });

      const result = await response.json();

      if (result.success) {
        alert("Videos added successfully!");
        setNewLinks("");
        setSelectedType("");
        loadVideos();
      } else {
        alert("Error adding videos!");
      }
    } catch (error) {
      console.error("Error adding videos:", error);
    }
  };

  // Delete video
  const handleDeleteVideo = async (id) => {
    if (!window.confirm("Are you sure you want to delete this video?")) return;

    try {
      const formData = new FormData();
      formData.append("id", id);

      const response = await fetch("https://api.backofficemain.com/delete_video.php", {
        method: "POST",
        body: formData,
      });

      const result = await response.json();
      if (result.success) {
        setVideos(videos.filter((v) => v.id !== id));
      } else {
        alert("Error deleting video!");
      }
    } catch (error) {
      console.error("Error deleting video:", error);
    }
  };

  return (
    <div className="content-container">
      <div className="content-header">
        <h2>Youtube Videos</h2>
        <p>You have total {videos.length} videos.</p>
      </div>

      <div className="video-add-card">
        <h3>Add New Videos</h3>
        <p className="sample-text">
          Sample link:{" "}
          <span>https://www.youtube.com/watch?v=OLEA8tHgsGU</span>
        </p>

        <textarea
          placeholder="Enter one YouTube link per line..."
          value={newLinks}
          onChange={(e) => setNewLinks(e.target.value)}
        ></textarea>

        <select
          value={selectedType}
          onChange={(e) => setSelectedType(e.target.value)}
        >
          <option value="">Please choose a category...</option>
          {types.map((t) => (
            <option key={t.no} value={t.no}>
              {t.type_name}
            </option>
          ))}
        </select>

        <button onClick={handleAddVideos}>Add</button>
      </div>

      <div className="video-list-container">
        <h3>Youtube Videos</h3>
        {videos.map((video) => {
          const videoId =
            video.video_link.includes("v=")
              ? video.video_link.split("v=")[1]
              : video.video_link;
          return (
            <div key={video.no} className="video-row-card">
              <div className="video-thumb">
                <img
                  src={`https://img.youtube.com/vi/${videoId}/hqdefault.jpg`}
                  alt="thumbnail"
                />
              </div>
              <div className="video-info">
                <a
                  href={video.video_link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="video-link"
                >
                  {video.video_link}
                </a>
                <div className="video-meta">
                  <span className="badge">{video.type_name}</span>
                </div>
              </div>
              <button
                className="delete-btn"
                onClick={() => handleDeleteVideo(video.id)}
                title="Delete video"
              >
                🗑️
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default VideoYoutubeList;
